export const MIN_REFERRAL_LENGTH = 2;
export const MAX_REFERRAL_LENGTH = 16;

export const REFERRAL_CODE_ERRORS = {
  TOO_SHORT: `Referral code must contain at least ${MIN_REFERRAL_LENGTH} characters`,
  TOO_LONG: `Referral code must not exceed ${MAX_REFERRAL_LENGTH} characters`,
  INVALID_CHARS: 'Referral code can only contain letters, numbers and underscore',
  RESERVED: 'Sorry, this referral code is already taken',
} as const;

export type ReferralCodeError = keyof typeof REFERRAL_CODE_ERRORS;

export const getReferralCodeError = (value: string): ReferralCodeError | null => {
  if (!value || value.length < MIN_REFERRAL_LENGTH) {
    return 'TOO_SHORT';
  }

  if (value.length > MAX_REFERRAL_LENGTH) {
    return 'TOO_LONG';
  }

  if (!/^\w+$/.test(value)) {
    return 'INVALID_CHARS';
  }

  return null;
};

export const generateReferralCode = (length: number = 12): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_';
  const maxLength = Math.min(length, MAX_REFERRAL_LENGTH);

  return Array.from({ length: maxLength }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
};
